module.exports = __webpack_public_path__ + "static/media/menuStar.afe138ba.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/menuStar.svg
// module id = 484
// module chunks = 0